import { CanvasObject, ObjectComposition } from 'components/canvas/CanvasObject';

export default class DigitRect extends ObjectComposition {
  constructor(id, locked, coords, label) {
    let objId = 'DigitRect.' + id;
    super(
      objId,
      [
        new DigitRectHandle(objId + '.tl', locked, coords[0], coords[1], 8),
        new DigitRectHandle(objId + '.br', locked, coords[2], coords[3], 8)
      ]
    );
    this.label = label;
  }

  drawBefore(ctx) {
    const x1 = Math.round(this.objects[0].x);
    const y1 = Math.round(this.objects[0].y);
    const x2 = Math.round(this.objects[1].x);
    const y2 = Math.round(this.objects[1].y);

    ctx.save();
    ctx.translate(0.5, 0.5);
    let color = '#0088cc'
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.setLineDash([3, 1]);
    ctx.strokeRect(x1, y1, x2 - x1 + 1, y2 - y1 + 1);
    ctx.restore();

    if (this.label) {
      if (this.active) {
        color = 'yellow'
      } else {
        switch (this.label) {
          case 1:
            color = "#8F8F8F";
            break;
          case 10:
            color = "#B4B4B4";
            break;
          case 100:
            color = "#DADADA";
            break;
          case 1000:
            color = "#F3F3F3";
            break;
          default:
            color = 'white';
            break;
        }
      }
      ctx.fillStyle = ctx.strokeStyle;
      ctx.fillStyle = color;
      ctx.strokeStyle = 'black';
      ctx.textBaseline = 'top';
      ctx.textAlign = 'center';
      ctx.lineWidth = 2;
      ctx.font = "14px Arial";
      ctx.strokeText(this.label, (x1 + x2) / 2, y2 + 5);
      ctx.fillText(this.label, (x1 + x2) / 2, y2 + 5);
    }
  }

  size() {
    return {
      width: Math.abs(this.objects[0].x - this.objects[1].x),
      height: Math.abs(this.objects[0].y - this.objects[1].y)
    };
  }

  setSize(size) {
    this.objects[1].x = this.objects[0].x + size.width;
    this.objects[1].y = this.objects[0].y + size.height;
  }

  export() {
    return [
      Math.round(this.objects[0].x),
      Math.round(this.objects[0].y),
      Math.round(this.objects[1].x),
      Math.round(this.objects[1].y)
    ];
  }
}

class DigitRectHandle extends CanvasObject {
  draw(ctx) {
    const { x, y, locked } = this;

    ctx.beginPath();
    ctx.arc(x, y, 2, 0, Math.PI * 2, false);
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 2;
    ctx.fillStyle = this.active ? 'yellow' : 'white';
    ctx.stroke();
    ctx.fill();
  }
}



// WEBPACK FOOTER //
// ./client/components/canvas/DigitRect.js